import {
  FormFieldsCustomizer,
  checkbox,
  datepicker,
  fieldGroup,
  header,
  input,
  number,
  repeatTable,
} from '@kinet-open-network/client/core/forms/ui';
import { selectLazyStockItems } from '@kinet-open-network/client/stock-items/data-access';
import {
  PubStockItemDetailComponent,
  StockItemAdrTabComponent,
  StockItemGeneralTabComponent,
} from '@kinet-open-network/client/stock-items/feature/detail';

export const stockItemFieldsCustomizer: FormFieldsCustomizer<
  StockItemGeneralTabComponent
> = (fields, context) => {
  const service = context.service;

  if (!service) {
    throw new Error('Service is required for stock item fields customizer');
  }

  fields.push(
    ...[
      fieldGroup()
        .fieldGroupClassName(
          'grid grid-cols-[repeat(auto-fit,minmax(210px,1fr))] gap-x-4 items-center',
        )
        .fieldGroup([
          header('Základné údaje'),
          input('shortName', 'Skrátený názov'),
          input('manufacturer', 'Výrobca'),
          input('prototypeCode', 'Kód prototypu'),
          input('serialNumberDevice', 'Sériové číslo flaše'),
          input('partnerExtId', 'ID partnera'),
          input('nsCode', 'Kód NS'),
          input('iaCode2', 'Kód IA2'),
          number('type', 'Typ').props({ minDecimals: 0, maxDecimals: 0 }),
          number('itemOrder', 'Poradie položky'),
          header('Predaj a sklad'),
          input(
            'gasFeeItemSku',
            'SKU položky pre poplatok za plyn',
          ).nullIfEmpty(),
          input('onixBottleSaleSku', 'SKU Predajny obal').nullIfEmpty(),
          header('Fyzikálne vlastnosti'),
          number('bottleWeight', 'Hmotnosť fľaše'),
          number('gasWeight', 'Hmotnosť náplne'),
          input('manufacturingDate', 'Dátum výroby'),
          header('Tlakové skúšky a plnenie'),
          datepicker('pressureTestDate', 'Dátum tlakovej skúšky'),
          datepicker('pressureTestExpirationDate', 'Platnosť tlakovej skúšky'),
          datepicker('lastFillDate', 'Posledné plnenie'),
          input('lastFilledBy', 'Plnené v'),
          header('Nastavenia'),
          checkbox('box', 'Paleta alebo box').disabled('!model?.trackSn'),
          checkbox('includeInRentalInvoice', 'Zahrnúť do faktúry za prenájom'),
          checkbox('specialWarranty', 'Špeciálna záruka'),
          header('Zloženie plynu').hide('!model?.trackSn'),
          repeatTable('composition')
            .hide((field) => !field.parent?.model?.trackSn)
            .className('col-span-full')
            .array(
              fieldGroup().fieldGroup([
                selectLazyStockItems(service, {
                  label: 'Položka',
                  forceFilters: 'trackSn eq false',
                  panelStyle: { 'min-width': '15vw' },
                }),
                number('quantity', 'Množstvo (kg)'),
                number('lossPercent', 'Strata (%)'),
              ]),
            ),
        ]),
    ].map((f) => f.build()),
  );
  return fields;
};

export const stockItemAdrFieldsCustomizer: FormFieldsCustomizer<
  StockItemAdrTabComponent
> = (fields) => {
  fields.push(
    ...[
      fieldGroup()
        .fieldGroupClassName(
          'grid grid-cols-[repeat(auto-fit,minmax(210px,1fr))] gap-x-4 items-start',
        )
        .fieldGroup([
          input('adrUnNumber', 'UN číslo'),
          input('adrText', 'ADR text').className('col-span-full'),
          input('adrSafetyTagNumber', 'Číslo bezpečnostnej značky'),
          input('adrRestrictiveTunnelCode', 'Obmedzujúci kód tunelu'),
          number('adrBottleContent', 'Obsah fľaše (kg/litrov)'),
          number(
            'adrTransportCategoryFullBottles',
            'Dopravná kategória (plné fľaše)',
          ),
          number(
            'adrTransportCategoryEmptyBottles',
            'Dopravná kategória (prázdne fľaše)',
          ),
          number('adrHazardPoints', 'Body nebezpečnosti'),
        ]),
    ].map((f) => f.build()),
  );

  return fields;
};

export const pubStockItemFieldsCustomizer: FormFieldsCustomizer<
  PubStockItemDetailComponent
> = (fields, context) => {
  fields.push(
    ...[
      input('manufacturer', 'Výrobca'),
      number('bottleWeight', 'Hmotnosť fľaše'),
      number('gasWeight', 'Hmotnosť náplne'),
      datepicker('pressureTestDate', 'Tlaková skúška')
        .view('month')
        .props({ dateFormat: 'mm/yy' }),
      datepicker('pressureTestExpirationDate', 'Platnosť tlakovej skúšky')
        .view('month')
        .props({ dateFormat: 'mm/yy' }),
      datepicker('lastFillDate', 'Posledné plnenie').props({
        dateFormat: 'dd.mm.yy',
      }),
      input('lastFilledBy', 'Plnené v'),
    ].map((f) => f.build()),
  );
  return fields;
};
